__turbopack_context__.v({
  "arrow": "Header-module__hBw1pG__arrow",
  "container": "Header-module__hBw1pG__container",
  "dropdown": "Header-module__hBw1pG__dropdown",
  "dropdownItem": "Header-module__hBw1pG__dropdownItem",
  "dropdownMenu": "Header-module__hBw1pG__dropdownMenu",
  "dropdownMenuOpen": "Header-module__hBw1pG__dropdownMenuOpen",
  "header": "Header-module__hBw1pG__header",
  "logo": "Header-module__hBw1pG__logo",
  "logoIcon": "Header-module__hBw1pG__logoIcon",
  "logoSubtext": "Header-module__hBw1pG__logoSubtext",
  "logoText": "Header-module__hBw1pG__logoText",
  "mobileMenuButton": "Header-module__hBw1pG__mobileMenuButton",
  "nav": "Header-module__hBw1pG__nav",
  "navLink": "Header-module__hBw1pG__navLink",
  "navLinkAdmin": "Header-module__hBw1pG__navLinkAdmin",
  "navOpen": "Header-module__hBw1pG__navOpen",
});
